import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JournalService } from '@journal/core/api/journal/journal.service';
import { UserService } from '@sparro/app/core/api/user/user.service';
import { User } from '@sparro/app/core/models/user.model';
import { environment } from '@journal/env/environment';

@Component({
  selector: 'app-redirect-check',
  templateUrl: './redirect-check.component.html',
  styleUrls: ['./redirect-check.component.scss']
})
export class RedirectCheckComponent implements OnInit {
  showSpinner: boolean = true;
  user: User;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private userService: UserService,
    public blogService: JournalService,

  ) { }

  ngOnInit(): void {
    this.userService.userInitialized.subscribe(
      (initialized: boolean) => {
        if (initialized) {
          this.userService.user.subscribe(
            (response: User) => {
              this.user = response;
              this.goToUploadJournal();
            });
        }
      });
  }

  goToUploadJournal(): void {
    const postData = {
      author: this.user.id,
    };
    this.blogService.createBlog(postData).subscribe(
      (response: any) => {
        if (response.uuid) {
          window.open(`${environment.postUrl}edit/${response.uuid}`, '_self');
        }
      });
  }

}
